export default {
  content: {
    id: 'product_jp_product_condition_screen_carousel_grade_c_content',
    defaultMessage:
      "There are scratches and dents visible from a distance of 50cm, but they don't affect the functionality.",
  },
  contentNew: {
    id: 'product_jp_product_condition_screen_carousel_grade_c_content_new',
    defaultMessage: 'Minor scratches',
  },
  pill1: {
    id: 'product_jp_product_condition_screen_carousel_grade_c_pill_1',
    defaultMessage: 'Verified parts',
  },
  grade: {
    id: 'product_jp_grade_12',
    defaultMessage: 'C grade (Fair)',
  },
}
